import React from 'react'
import { StockReportsSummaryDataType, TotalStockReportsSummaryDataType } from '../../../../redux/reports/reportsType'
import { currencySignAndNegativeValueAdjust } from '../../../../utils/commonFunctions';
import { Link } from 'react-router-dom';

type AppProps = {
  client_code: number;
  startDate: string;
  endDate: string;
  company_name: string;
  currencySign: string | undefined;
  stockReportsSummaryData: [] | StockReportsSummaryDataType[];
  totalStockReportsSummaryData: TotalStockReportsSummaryDataType;
}

const StockReportsSummaryTableData = ({
  client_code,
  stockReportsSummaryData,
  totalStockReportsSummaryData,
  startDate,
  endDate,
  company_name,
  currencySign
}: AppProps) => {

  const toFixedDecimalNumber = (data: number) => {
    return data === 0 ?`${currencySign}0` : currencySignAndNegativeValueAdjust(currencySign,data?data?.toFixed(2)?.toString():"0")   
  }

  const renderTotaldata = () => {
    return (
      <>
        <tr className='text-center' style={{ backgroundColor: "#d1d0cf", color: "white" }}>
          <td className='font-weight-bold text-dark'>Total</td>
          <td></td>
          <td></td>
          <td className='font-weight-bold text-dark'>{currencySignAndNegativeValueAdjust(currencySign,totalStockReportsSummaryData?.total_opening_value?totalStockReportsSummaryData?.total_opening_value?.toString():"0")}</td>
          <td></td>
          <td></td>
          <td className='font-weight-bold text-dark'>{currencySignAndNegativeValueAdjust(currencySign,totalStockReportsSummaryData?.total_inwards_value?totalStockReportsSummaryData?.total_inwards_value?.toString():"0")}</td>
          <td></td>
          <td></td>
          <td className='font-weight-bold text-dark'>{currencySignAndNegativeValueAdjust(currencySign,totalStockReportsSummaryData?.total_outwards_value?totalStockReportsSummaryData?.total_outwards_value?.toString():"0")}</td>
          <td></td>
          <td></td>
          <td className='font-weight-bold text-dark'>{currencySignAndNegativeValueAdjust(currencySign,totalStockReportsSummaryData?.total_closing_value?totalStockReportsSummaryData?.total_closing_value?.toString():"0")}</td>
        </tr>
      </>
    )
  }

  const handleSetLocalStorageData=(stock_item_name:string)=>{
    localStorage.setItem('stock_item_name',stock_item_name);
    localStorage.setItem('start_date', startDate);
    localStorage.setItem('end_date', endDate);
  }

  const renderdata = () => {
    const data1 = stockReportsSummaryData?.map((e: any) => {
      const finalRedirectLink = {
        pathname: `/reports/${client_code}/stock-statement?sku_id=${e.sku_id}&client_code=${client_code}&company_name=${company_name}`,
      };
    
      return (
        <>
          <tr className='text-center' key={e.sku_id}>
            <td className='min-width text-start'>
              <Link
               className='pointer'
               target='_blank'
               to={finalRedirectLink}
               onClick={() => handleSetLocalStorageData(e.stock_item_name)}
               style={{ textDecoration:"underline",cursor:"pointer",color:"black",fontWeight:"500",textUnderlineOffset: '3px'}}>
              {(e.stock_item_name)}
              </Link>
            </td>
            <td className='text-nowrap'>{e.opening_qty} {e?.unique_quantity_code?.label?.slice(0,e?.unique_quantity_code?.label?.lastIndexOf("("))}</td>
            <td className='min-width'>{toFixedDecimalNumber(e.opening_rate)}</td>
            <td className='min-width' style={{minWidth:"150px"}}>{toFixedDecimalNumber(e.opening_value)}</td>
            <td className='text-nowrap'style={{ color: "#2080F6" }}>{e.inwards_qty} {e?.unique_quantity_code?.label?.slice(0,e?.unique_quantity_code?.label?.lastIndexOf("("))}</td>
            <td className='min-width' style={{ color: "#2080F6" }}>{toFixedDecimalNumber(e.inwards_rate)}</td>
            <td className='min-width' style={{ color: "#2080F6",minWidth:"150px" }}>{toFixedDecimalNumber(e.inwards_value)}</td>
            <td className='text-nowrap' style={{ color: "#7fb913" }}>{e.outwards_qty} {e?.unique_quantity_code?.label?.slice(0,e?.unique_quantity_code?.label?.lastIndexOf("("))}</td>
            <td className='min-width' style={{ color: "#7fb913" }}>{toFixedDecimalNumber(e.outwards_rate)}</td>
            <td className='min-width' style={{ color: "#7fb913",minWidth:"150px" }}>{toFixedDecimalNumber(e.outwards_value)}</td>
            <td className='text-nowrap'>{e.closing_qty} {e?.unique_quantity_code?.label?.slice(0,e?.unique_quantity_code?.label?.lastIndexOf("("))}</td>
            <td className='min-width'>{toFixedDecimalNumber(e.closing_rate)}</td>
            <td className='min-width' style={{minWidth:"150px"}}>{toFixedDecimalNumber(e.closing_value)}</td>
          </tr>
        </>
      )
    })
    return data1
  }
  return (
    <>
      {renderdata()}
      {renderTotaldata()}
    </>
  )
}

export default StockReportsSummaryTableData